// extracted by mini-css-extract-plugin
export var container = "Hero-module--container--d5642";
export var desktop = "Hero-module--desktop--cf66d";
export var illustration = "Hero-module--illustration--d59d0";
export var logo = "Hero-module--logo--697e9";
export var mobile = "Hero-module--mobile--84b01";
export var octobro = "Hero-module--octobro--6ac28";
export var root = "Hero-module--root--6ea2f";
export var wavesLeft = "Hero-module--wavesLeft--fedb3";
export var wavesRightBottom = "Hero-module--wavesRightBottom--b2b44";
export var wavesRightTop = "Hero-module--wavesRightTop--6fc18";